const parseCommaDecimal = (value = '') => parseFloat(String(value).replace(',', '.'));

export default parseCommaDecimal;